import Cta from "@components/Cta/Cta";
import { TypeNavLinkListSkeleton } from "@customTypes/contentful";
import { navigationGAClick } from "@utilities/navigationGAClick";
import clsx from "clsx";
import { useRouter } from "next/router";
import { FC } from "react";
import { useNavigationStateContext } from "../../context/navigationContext";
import styles from "./MegaNav.module.scss";

type Props = {
  linkList: TypeNavLinkListSkeleton;
};

export const PromoCTAs: FC<Props> = ({ linkList }) => {
  const mainMenuLink = linkList?.fields;
  const { handleReset } = useNavigationStateContext();
  const router = useRouter();

  return (
    <div className={clsx(styles.bottom, styles.desktop)}>
      <p>{mainMenuLink.description || ""}</p>

      {mainMenuLink.promoCtAs &&
        mainMenuLink.promoCtAs.slice(0, 2).map((promoCTA, index) => (
          <Cta
            key={`main-menu-link${index}`}
            btnTheme={styles["ctaBottom"]}
            linkText={promoCTA?.fields?.linkText}
            type={"secondary"}
            light
            url={promoCTA?.fields?.url}
            onClick={(e) => {
              navigationGAClick(e);
              handleReset();
              router.push(promoCTA?.fields?.url);
            }}
          />
        ))}
    </div>
  );
};

export default PromoCTAs;
